import React from 'react';

import { Table } from 'components/WrappedComponents';
import { ColumnProps } from 'components/WrappedComponents/Table/types';
import { SearchTypeWithSort } from 'types/searchType';

import './DashboardFlux.less';

interface DashboardFluxProps<
  DtoType extends object,
  FilterType,
  SortType extends string | undefined,
> {
  useSearchFlux: SearchTypeWithSort<DtoType, FilterType, SortType>;
  buildColumns: () => ColumnProps<DtoType, SortType>[];
  title: string;
  dateProchaineExecution?: string;
  buildItemKey?: (item: DtoType) => string;
}
function DashboardFlux<
  DtoType extends object,
  SortType extends string | undefined,
>({
  useSearchFlux,
  buildColumns,
  title,
  dateProchaineExecution,
  buildItemKey,
}: DashboardFluxProps<
  DtoType,
  Record<string, unknown>,
  SortType
>): React.ReactElement {
  const columns: ColumnProps<DtoType, SortType>[] = React.useMemo(
    () => buildColumns(),
    [],
  );

  return (
    <>
      <div className="dashboardFlux">
        <h1>{title}</h1>
        <h2>Prochain déclenchement : {dateProchaineExecution}</h2>
        <div className="tableContainer">
          <Table
            columns={columns}
            fetchData={useSearchFlux.fetchData}
            buildItemKey={buildItemKey}
            pageSizeOptions={[10, 20, 50]}
            pagination={useSearchFlux.pagination}
            setPagination={useSearchFlux.setPagination}
            setFilter={useSearchFlux.setFilter}
            setSort={useSearchFlux.setSort}
            sort={useSearchFlux.sort}
            filter={useSearchFlux.filter}
          />
        </div>
      </div>
    </>
  );
}

export default DashboardFlux;
